/**
 * The Claude connector, on the Waslo AI screens (services spec §8 P-8.4). Pure, except `leaveTo`,
 * which is the one navigation out of the dashboard and is kept here so a spec can stub it.
 */

/** The address she pastes into Claude, from the page's own origin: there is no config to read. */
export const connectorUrl = origin =>
  `${String(origin).replace(/\/+$/, '')}/authoring/mcp`;

/** The workspaces where she is an administrator, from Chatwoot's own current user. */
export const adminAccounts = user =>
  (Array.isArray(user?.accounts) ? user.accounts : [])
    .filter(a => a && a.role === 'administrator' && Number.isInteger(a.id))
    .map(a => ({
      id: a.id,
      name: typeof a.name === 'string' && a.name !== '' ? a.name : String(a.id),
    }));

/** "Claude suggested N changes": what waits for her, and what was drafted switched off. */
export const batchChangeCount = batch => batch.suggestions + batch.drafted;

/** One session's open proposals, in the order the BFF lists them (newest first). */
export const suggestionsOfBatch = (items, batchId) =>
  items.filter(s => s.batchId === batchId && s.status === 'open');

/** What still carries "Suggested by Claude", as sets the lists can ask. */
export const draftedSets = summary => ({
  tasks: new Set(summary?.drafted?.tasks ?? []),
  menus: new Set(summary?.drafted?.menus ?? []),
  connections: new Set(summary?.drafted?.connections ?? []),
});

/** The approved-message editor opens Claude's draft by its id, on a number when there is one. */
export const messageEditorQuery = (suggestionId, inboxId) => ({
  suggestion: String(suggestionId),
  ...(inboxId === null || inboxId === undefined
    ? {}
    : { inboxId: String(inboxId) }),
});

/** Back to Claude, after Allow or Cancel. A full navigation: it leaves the dashboard. */
export const leaveTo = url => {
  window.location.assign(url);
};
